// src/models/types.ts
let ReferralProgramStatusEnum = /* @__PURE__ */ function(ReferralProgramStatusEnum) {
	ReferralProgramStatusEnum["Active"] = "active";
	ReferralProgramStatusEnum["Expired"] = "expired";
	ReferralProgramStatusEnum["Eligible"] = "eligible";
	return ReferralProgramStatusEnum;
}({});
let ExperienceFlowEnum = /* @__PURE__ */ function(ExperienceFlowEnum) {
	ExperienceFlowEnum["Default"] = "default";
	ExperienceFlowEnum["Astrazeneca"] = "astrazeneca";
	return ExperienceFlowEnum;
}({});
let PaymentMethodEnum = /* @__PURE__ */ function(PaymentMethodEnum) {
	PaymentMethodEnum["Default"] = "default";
	PaymentMethodEnum["Sponsored"] = "sponsored";
	return PaymentMethodEnum;
}({});
const SIGNUP_TRIAL_DURATION_DAYS = 14;

export { ExperienceFlowEnum, PaymentMethodEnum, ReferralProgramStatusEnum, SIGNUP_TRIAL_DURATION_DAYS };
//# sourceMappingURL=types.mjs.map